module.exports = __webpack_public_path__ + "static/media/mail.cd95a727.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/contacto/mail.svg
// module id = 184
// module chunks = 0